// extracted by mini-css-extract-plugin
export var button = "CalloutBanner-module--button--784qC";
export var container = "CalloutBanner-module--container--xtBje";
export var content = "CalloutBanner-module--content--7pgJU";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";